import { db } from "../../../config/firebaseconfig";
import uuid from 'uuid/v1'

export default function resetPassword(record) {
  const id = uuid()
  const time = Date.now()
  return db.collection('passwordResets').doc(id).set({
    id,
    userId: record.id,
    createdDate: time,
    expirationDate: time + 3600000,
    email: record.email,
    sent: false,
    firstName: record.firstName,
    lastName: record.lastName,
    complete: false,
  })
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/resetPassword.js